// extracted by mini-css-extract-plugin
module.exports = {"seasons":"CJ","seasonsSelector":"CK","oneSeasonSelector":"CL","emblaViewport":"CM","episodes":"CN","emblaSlide":"CO","textActive":"CP"};